import styled, { css } from 'styled-components';

export const FieldWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: var(--text-color-50);
`;

export const StyledInput = styled.input`
  height: 48px;
  width: 100%;
  border: 1px solid var(--gray-350);
  border-radius: 12px;
  background: var(--white);
  padding: 0 16px;
  font-size: 15px;
  color: var(--text-color-50);
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: rgba(49, 49, 49, 0.3);
    box-shadow: 0 0 0 2px rgba(49, 49, 49, 0.08);
  }

  &::placeholder {
    color: var(--text-color);
  }
`;

export const PasswordInput = styled(StyledInput)`
  padding-right: 44px;
`;

export const StyledOutlineButton = styled.button`
  display: inline-flex;
  width: 100%;
  height: 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid var(--gray-350);
  border-radius: 12px;
  background: var(--white);
  font-weight: 500;
  color: var(--text-color-50);
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: var(--gray-100);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledContinueButton = styled.button`
  display: inline-flex;
  width: 100%;
  height: ${({ $large }) => ($large ? '56px' : '52px')};
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  border-radius: 12px;
  background-image: var(--onboarding-brand-gradient);
  font-size: 15px;
  font-weight: 600;
  color: var(--white);
  box-shadow: var(--onboarding-shadow-elevated);
  cursor: pointer;
  transition: box-shadow 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    box-shadow: ${({ $large }) =>
    $large ? 'var(--onboarding-shadow-continue-hover)' : 'var(--onboarding-shadow-elevated)'};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
  }

  &:hover:not(:disabled) svg {
    transform: translateX(2px);
  }
`;

export const QuestionWrap = styled.div``;

export const QuestionLabel = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: var(--text-color-50);
`;

export const QuestionContent = styled.div`
  margin-top: 12px;
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const StyledChip = styled.button`
  height: 36px;
  padding: 0 16px;
  border-radius: 9999px;
  border: 1px solid var(--gray-350);
  background: var(--white);
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color-50);
  cursor: pointer;
  transition: all 0.2s ease;

  ${({ $active }) =>
    $active
      ? css`
          border-color: transparent;
          background-image: var(--onboarding-brand-gradient);
          color: var(--white);
          box-shadow: var(--onboarding-shadow-soft);
        `
      : css`
          &:hover {
            border-color: rgba(49, 49, 49, 0.3);
          }
        `}
`;

export const IconCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const IconCardButton = styled.button`
  position: relative;
  overflow: hidden;
  padding: 1px;
  border: none;
  border-radius: 20px;
  background: ${({ $active }) => ($active ? 'var(--onboarding-brand-gradient)' : 'var(--gray-350)')};
  box-shadow: ${({ $active }) => ($active ? 'var(--onboarding-shadow-elevated)' : 'none')};
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ $active }) => ($active ? 'var(--onboarding-brand-gradient)' : 'var(--gray-150)')};
  }
`;

export const IconCardInner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  background: var(--white);
  padding: 12px 14px;
  text-align: left;

  .check-icon{
    flex-shrink: 0;
  }
`;

export const IconCardIcon = styled.span`
  display: grid;
  place-items: center;
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? 'var(--onboarding-brand-gradient)' : 'var(--gray-200)')};
  color: ${({ $active }) => ($active ? 'var(--white)' : 'var(--text-color)')};

  svg {
    width: 16px;
    height: 16px;

  }
`;

export const IconCardLabel = styled.span`
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-color-50);
`;

export const StatusDot = styled.span`
  display: grid;
  place-items: center;
  width: ${({ $done }) => ($done ? '20px' : '24px')};
  height: ${({ $done }) => ($done ? '20px' : '24px')};
  border-radius: 9999px;
  background: ${({ $done }) => ($done ? 'var(--onboarding-brand-gradient)' : 'transparent')};

  svg {
    width: 12px;
    height: 12px;
    color: var(--white);
  }
`;

export const PendingDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: rgba(141, 141, 141, 0.4);
`;

export const StepWrap = styled.div`
  animation: stepFadeIn 0.4s cubic-bezier(0.22, 1, 0.36, 1);

  @keyframes stepFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
